import { css, CSSResult } from 'lit'
import { csColorBackground } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csShadow } from '@cloudsuite/mosaic-shared/styles/shadows.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cseDropdownMenu = {
  backgroundColor: css`var(--cse-dropdown-menu-background-color, ${csColorBackground.primary})`,
  borderRadius: css`var(--cse-dropdown-menu-border-radius, ${csBorder.radiusNone})`,
  boxShadow: css`var(--cse-dropdown-menu-box-shadow, ${csShadow.default})`,
  paddingInline: css`var(--cse-dropdown-menu-padding-x, ${csSpacing.spacing05})`,
  paddingBlock: css`var(--cse-dropdown-menu-padding-y, ${csSpacing.spacing05})`,
  gap: css`var(--cse-dropdown-menu-gap, ${csSpacing.spacing05})`,
}

export const style: CSSResult = css`
  .cse-dropdown-menu {
    background-color: ${cseDropdownMenu.backgroundColor};
    border-radius: ${cseDropdownMenu.borderRadius};
    box-shadow: ${cseDropdownMenu.boxShadow};
    display: flex;
    flex-direction: column;
    max-width: var(--cse-popup-auto-size-available-width); /* special var that is defined in cse-popup ts */
    max-height: var(--cse-popup-auto-size-available-height); /* special var that is defined in cse-popup ts */
    overflow: auto;
    overscroll-behavior: none;
    padding-block: ${cseDropdownMenu.paddingBlock};
    padding-inline: ${cseDropdownMenu.paddingInline};
    row-gap: ${cseDropdownMenu.gap};
  }
`
